
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlE as ObiOwnShipControlEElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-e.js';
 
 
 

 
 export const ObiOwnShipControlE = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-e',
   elementClass: ObiOwnShipControlEElement,
   events: {
     
   }
  });
 
 